import { toast } from "react-hot-toast";

export const successToast = (msg, position) =>
  toast.success(msg, {
    duration: 3000,
    position,
  });

export const errorToast = (msg, position) =>
  toast.error(msg, {
    duration: 3000,
    position,
  });

export const infoToast = (msg, position) =>
  toast(msg, {
    icon: "ℹ",
    duration: 3000,
    position,
  });
